module.exports = __webpack_public_path__ + "img/UT0420.771bb37c.png";